import React from 'react';
import { observer } from 'mobx-react';
import SupportComponent from './Support.component';
import useSupport from './useSupport';

const Container: React.FC = () => {
    const { map, lang, user, devices, state, handlers } = useSupport();

    return (
        <>
            <SupportComponent
                devices={devices.supportList}
                fromDateFilterCurrent={state.fromDateFilterCurrent}
                toDateFilterCurrent={state.toDateFilterCurrent}
                dateFilter={map.dateFilter}
                lang={lang.lang}
                selectedDevice={map.selectedDevice}
                trackMode={map.trackMode}
                timezone={user.settings.timezone ?? 0}
                onFromDateChange={handlers.handleFromDateChange}
                onToDateChange={handlers.handleToDateChange}
                onDateFilterChange={handlers.handleDateFilterChange}
                onDeviceChange={handlers.handleDeviceChange}
                onSwitchTrackMode={handlers.handleSwitchTrackMode}
                onUpdateClick={handlers.handleUpdateClick}
                onSettingsOpen={handlers.handleSettingsOpen}
            />
        </>
    );
};

const SupportContainer = observer(Container);

export default SupportContainer;
